export const topBarHeight = 64;
export const sideNavWidth = 300;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;

export const MS_PER_DAY = 1000 * 60 * 60 * 24;

export const STATUS = {
  REGISTERED: "Telah Registrasi",
  DONE_TAKING_SCHEDULE: "Telah Memilih Jadwal",
  NOTIFICATION_H1: "Telah Direminder H-1",
  DONE_CLEANING: "Telah Dibersihkan",
  ALL_DONE: "Selesai",
  NONE: "None",
};

// export STATUS_ALREADY_SCHEDULE = "Telah Mengambil Jadwal"
// export STATUS_REMINDER="Telah Direminder H-1"
// export STATUS_A="Telah Dibersihkan"
